$(function () {
  var offset = $('.product-grid-items > li:last-child').offset().top;
  var loading = false;

  $(window).resize(function () {
    setTimeout(function () {
      offset = $('.product-grid-items > li:last-child').offset().top;
    }, 500);
  });

  $(document).on('scroll', function () {
    var scrollPos = $(document).scrollTop() + $(window).height();
    if (scrollPos > offset && !loading && nextUrl.includes('page=')) {
      loading = true;
      $.ajax(nextUrl + "&view=pagination-ajax")
        .done(function (data) {
          $('.product-grid-items').append(data);
          $('.product-grid-items').find('script').remove();
          setTimeout(function () {
            $('.product-grid-items > li').removeClass('faded');
            offset = $('.product-grid-items').find('.grid__item').last().offset().top;
          }, 200);
        })
        .fail(function (error) {
          console.error(error);
        })
        .always(function () {
          loading = false;
        });
    }
  });
});